import { Page } from "lola-framework-ui-test";
import { Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RotateToPortraitOverlay } from "./components/RotateToPortraitOverlay";
import { useReadTheme } from "./hooks/useReadTheme";
import { useMaintenanceWatch } from "./hooks/useMaintenanceWatch";
import { useSessionExpiredHandler } from "./hooks/useSessionExpiredHandler";
import { OfflineOverlay } from "./components/OfflineOverlay";
import { useLinkExpiryWatch } from "./hooks/useLinkExpiryWatch";
import { useTabResumeLinkLiveness } from "./hooks/useTabResumeLinkLiveness";
import { useLanguageSync } from "./hooks/useLanguageSync";
import { useSessionBootstrap } from "./hooks/useSessionBootstrap";
import { usePartnerFavicon } from "./hooks/usePartnerFavicon";
import { useSessionStore } from "./store/useSessionStore";
import { ErrorBoundary } from "./shared/error/ErrorBoundary";
import { routesList } from "./utils";
import { NovuInboxProvider } from "./components/notifications/NovuInboxProvider";

const App = () => {
  const { t } = useTranslation();
  const linkId = useSessionStore((s) => s.session.data?.linkId);
  // Resolve the theme: default theme.json first, then the partner theme that
  // arrives inside the claimed link.
  const { reedTheme } = useReadTheme();

  // Handle session expired events globally
  useSessionExpiredHandler();
  useMaintenanceWatch();
  useTabResumeLinkLiveness();
  useLinkExpiryWatch();

  // Re-sync i18n language from the persisted session after a refresh
  useLanguageSync();

  // Restore widget link id + global linkId after refresh / HMR
  useSessionBootstrap();
  usePartnerFavicon(linkId);

  return (
    <Page
      font={{
        cdn: reedTheme.font.fontcdn,
        name: reedTheme.font.fontfamily,
      }}
    >
      <ErrorBoundary>
        <NovuInboxProvider>
          <Routes>
            {routesList.map(({ path, Component }) => (
              <Route key={path} path={path} Component={Component} />
            ))}
          </Routes>
        </NovuInboxProvider>
      </ErrorBoundary>
      <RotateToPortraitOverlay
        title={t("orientation.title")}
        subtitle={t("orientation.subtitle")}
      />
      <OfflineOverlay />
    </Page>
  );
};

export default App;
